import React, { Component } from "react";
import { Link } from "react-router-dom";

import { request } from "../utils/request";
import { AppContext } from "../utils/context";
import { formatCurrency } from "../utils/constants";
import RemainingCardsEnvelopes from "../components/RemainingCardsEnvelopes";

class Winners extends Component {
  state = { winners: [], isEmptyState: false };
  componentDidMount = () => {
    return request.get("api:/web/winners", {}).then(resp => {
      this.setState({
        winners: resp.data
      });
    });
  };

  render() {
    const { winners } = this.state;
    const { language, settings } = this.context;
    let fill = "w-1/3";
    return (
      <div className={`container mx-auto py-6 winnersPage`}>
        <h1 className="mb-6 text-accent">Winners</h1>
        {winners && winners.map((v, k) => (
          <div key={`eventSelection${k}`}>
            <div className="block mx-auto my-4 overflow-hidden rounded-lg no-underline bg-accent">
              <div className="flex items-start px-6 py-4">
                <div className="bg-grey-lighter rounded-full px-3 py-1 m-auto text-xs font-semibold text-grey-darker">{v.game.title}</div>
                <div className="flex-grow m-auto text-center font-bold text-white text-xl">{v.game.title} Winners</div>
                {v.game_id === 3 && <RemainingCardsEnvelopes event={v.threads[0]} settings={settings} language={language}></RemainingCardsEnvelopes>}
              </div>
              <div className="hidden md:flex flex-wrap bg-secondary font-bold py-4">
                <div className={`w-full md:w-1/6 text-accent px-2`} > Date </div>
                <div className={`w-full md:${fill} text-accent px-2`} > Event </div>
                <div className={`w-full md:w-1/3 text-accent px-2`} > Winning Number </div>
                <div className={`w-full md:w-1/6 text-accent px-2`} > </div>
              </div>
              {v.threads.map(t => {
                if (t.draws.length === 0) return null;
                return t.draws.map((d, i) => {
                  if (+d.is_hidden === 1) return null;
                  return (
                    <div
                      key={`winner-row-${i}`}
                      className={
                        Number.isInteger(i / 2)
                          ? "flex flex-wrap bg-grey-lighter py-4"
                          : "flex flex-wrap bg-white py-4"
                      }
                    >
                      <div className={`w-full md:w-1/6 px-2`}>
                        <span className="inline md:hidden font-bold">
                          Date:{" "}
                        </span>
                        {d.draw_at}
                      </div>
                      <div className={`w-full md:${fill} px-2`}>
                        <span className="inline md:hidden font-bold">
                          Event:{" "}
                        </span>
                        {t.title}
                      </div>
                      <div className={`w-full md:w-1/6 px-2`}>
                        <span className="inline md:hidden font-bold">
                          Winning Number:{" "}
                        </span>
                        {d.number}
                        {(!t.thread_is_final || !d.is_grand || (t.thread_is_final && d.is_grand)) && d.card && (
                          <div>
                            <span className="inline md:hidden font-bold">
                              Card:{" "}
                            </span>
                            {d.card.suit === "D" ? (
                              <span style={{ color: "red" }}>
                                &diams;
                              </span>
                            ) : (
                                ""
                              )}
                            {d.card.suit === "H" ? (
                              <span style={{ color: "red" }}>
                                &hearts;
                              </span>
                            ) : (
                                ""
                              )}
                            {d.card.suit === "S" ? (
                              <span>&spades;</span>
                            ) : (
                                ""
                              )}
                            {d.card.suit === "C" ? (
                              <span>&clubs;</span>
                            ) : (
                                ""
                              )}
                            {" " + d.card.rank} in Envelope: #
                            {d.card.envelope}
                          </div>
                        )}
                      </div>
                      <div className={`w-full md:w-1/3 px-2`}>
                        {+settings.show_weekly_jackpot === 1 && (
                          <span className="inline font-bold">
                            {v.game_id === 2 ? "Prize: " : `${d.title}: `}
                          </span>
                        )}
                        {v.game_id === 2 ?
                          d.title : (d.winning_card && !t.draws[1] ?
                            formatCurrency(Math.floor(+d.jackpot)) : (+settings.show_weekly_jackpot === 1 ?
                              formatCurrency(Math.floor(t.thread_is_final && d.is_grand ?
                                +d.jackpot : +d.prize
                              ))
                          : ""))
                        }
                        {v.game.id === 3 && d.winning_card && !t.draws[1] && (
                          <div>
                            {+settings.show_weekly_jackpot === 1 && (
                              <span className="inline font-bold">
                                {language.en[`game_${v.game.id}_prize_title`]}:{" "}
                              </span>                              
                            )
                            }
                            {+settings.show_weekly_jackpot === 1 && formatCurrency(Math.floor(+d.prize))}
                          </div>
                        )}
                        {t.thread_is_final && d.winning_card ? (<div className="text-xs italic mt-1">See <Link to='/rules'>Rules</Link> for {language.en[`game_${v.game.id}_final_draw`]}</div>) : ""}
                      </div>
                    </div>
                  )
                })
              })}
              <div className="flex justify-around  bg-primary text-base">
                <div
                  className="flex items-center leading-normal bg-secondary border-secondary rounded m-4	 whitespace-no-wrap text-white font-semibold"
                >
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
Winners.contextType = AppContext;

export default Winners;
